import { render, staticRenderFns } from "./company-shipping-card-edit.vue?vue&type=template&id=2302b7fa&scoped=true&"
import script from "./company-shipping-card-edit.vue?vue&type=script&lang=js&"
export * from "./company-shipping-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./company-shipping-card-edit.vue?vue&type=style&index=0&id=2302b7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2302b7fa",
  null
  
)

export default component.exports